import MilkReceiptIcon from './milk-receipt-icon';
export default MilkReceiptIcon;
